import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_PORTAL_URL } from '../utils/adminPortal';

const AdminPortalRedirect = () => {
  useEffect(() => {
    if (ADMIN_PORTAL_URL) window.location.replace(ADMIN_PORTAL_URL);
  }, []);
  return <section className="container"><h1>Portail d’administration</h1><p>L’administration PhotoChap dispose de son propre portail.</p>{ADMIN_PORTAL_URL && <p><a className="btn-primary" href={ADMIN_PORTAL_URL}>Ouvrir l’administration</a></p>}<Link to="/dashboard">Retour à mon espace</Link></section>;
};

export default AdminPortalRedirect;
